import React from 'react';

const PitcherCard = ({ label, name, personId, stats, color, onPlayerClick }) => (
  <div
    className="flex-1 border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] border-l-4 cursor-pointer hover:bg-[rgba(255,255,255,0.04)] transition-colors group"
    style={{ borderLeftColor: color }}
    onClick={() => personId && onPlayerClick && onPlayerClick(personId, name)}
  >
    <span className="text-[9px] uppercase tracking-widest font-bold text-[#658d71]">{label}</span>
    <p className="text-sm font-black uppercase tracking-wide text-white mt-0.5 truncate group-hover:text-[#d8ceb3] transition-colors">
      {name || '--'}
    </p>
    {personId && (
      <span className="text-[8px] text-[#658d71] group-hover:text-[#a9c9b1] transition-colors uppercase tracking-widest font-bold">
        View Profile →
      </span>
    )}
    {stats && (
      <div className="flex gap-3 mt-1.5">
        {Object.entries(stats).map(([k, v]) => (
          <div key={k} className="flex flex-col items-center">
            <span className="text-[9px] text-[#658d71] uppercase tracking-widest font-bold">{k}</span>
            <span className="text-xs font-black text-[#d8ceb3] tabular-nums">{v ?? '--'}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

const RecapDecisionsClickable = ({ game, feed, onPlayerClick }) => {
  const decisions = game?.decisions || feed?.liveData?.decisions;
  const boxscore = feed?.liveData?.boxscore;

  const getPitcherStats = (personId) => {
    if (!boxscore || !personId) return null;
    for (const side of ['away', 'home']) {
      const players = boxscore.teams?.[side]?.players || {};
      const key = `ID${personId}`;
      if (players[key]) {
        const p = players[key].stats?.pitching;
        return p
          ? { IP: p.inningsPitched, K: p.strikeOuts, ER: p.earnedRuns, BB: p.baseOnBalls }
          : null;
      }
    }
    return null;
  };

  if (!decisions) return (
    <div className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">
      No decision data available
    </div>
  );

  return (
    <div>
      <p className="text-[10px] text-[#658d71] uppercase tracking-widest mb-1 font-bold">Pitching Decisions</p>
      <p className="text-[9px] text-[#658d71] mb-3 tracking-widest">Click a pitcher to view their profile</p>
      <div className="flex gap-3 flex-wrap sm:flex-nowrap">
        <PitcherCard
          label="Win"
          name={decisions.winner?.fullName}
          personId={decisions.winner?.id}
          stats={getPitcherStats(decisions.winner?.id)}
          color="#a9c9b1"
          onPlayerClick={onPlayerClick}
        />
        <PitcherCard
          label="Loss"
          name={decisions.loser?.fullName}
          personId={decisions.loser?.id}
          stats={getPitcherStats(decisions.loser?.id)}
          color="#c4333e"
          onPlayerClick={onPlayerClick}
        />
        {decisions.save?.id && (
          <PitcherCard
            label="Save"
            name={decisions.save?.fullName}
            personId={decisions.save?.id}
            stats={getPitcherStats(decisions.save?.id)}
            color="#d8ceb3"
            onPlayerClick={onPlayerClick}
          />
        )}
      </div>
    </div>
  );
};

export default RecapDecisionsClickable;